import styled from 'styled-components';

import { colors, spacing, borderRadius } from '../../../../../styles/theme';

type IconProps = {
  type: 'danger' | 'warning';
};

export const Container = styled.div<IconProps>`
  display: flex;
  width: calc(100% - 28px);
  margin-top: ${spacing('3')};
  background: ${colors('white.90')};
  align-items: center;
  padding: ${spacing('1')};
  box-shadow: 2px 2px 4px ${colors('black.08')};
  border-radius: ${borderRadius('base')};

  border-left: ${({ type }: IconProps) => colors(`${type}.light`)} solid 14px;
`;

export const ContainerChildren = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: ${spacing('2')};
`;
